import React from 'react'
import { Typography, Chip, CircularProgress } from '@material-ui/core'
import { NOTE_KIND_LABELS, PRIORITY_COLORS } from '../../constants/contextEnums'

const NotesTab = ({ items, loading, onEdit }) => {
  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}><CircularProgress size={20} /></div>
  if (items.length === 0) {
    return <Typography variant="body2" color="textSecondary" style={{ padding: 24, textAlign: 'center' }}>No notes yet. Add a note to track scope details or assumptions.</Typography>
  }

  const truncate = (str, len) => {
    if (!str) return ''
    return str.length > len ? str.slice(0, len) + '...' : str
  }

  return items.map((note) => (
    <div
      key={note._id}
      style={{ padding: '10px 0', borderBottom: '1px solid var(--line-1, #eee)', cursor: 'pointer' }}
      onClick={() => onEdit('note', note)}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <Chip label={NOTE_KIND_LABELS[note.kind] || note.kind} size="small" style={{ height: 20, fontSize: 11 }} />
        {note.priority && note.priority !== 'normal' && (
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: PRIORITY_COLORS[note.priority] || '#9e9e9e' }} />
        )}
        {note.parent_label && (
          <Chip label={note.parent_label} size="small" variant="outlined" style={{ height: 18, fontSize: 10 }} />
        )}
      </div>
      <div style={{ fontSize: 13, fontWeight: 500 }}>{note.title}</div>
      {note.body && <div style={{ fontSize: 12, color: 'var(--ink-3)', marginTop: 2 }}>{truncate(note.body, 100)}</div>}
    </div>
  ))
}

export default NotesTab
